import { isTesting, macroCondition } from '@embroider/macros';
import { timeout as _timeout } from 'ember-concurrency';

const DURATION = {
  'extra-short': 25,
  default: 250,
  'extra-long': 2000,
} as const;

type Duration = keyof typeof DURATION;

/**
 * ⚠️ For now, only allowed in an `ember-concurrency` task.
 */
export async function timeout(duration?: Duration): Promise<void> {
  if (macroCondition(isTesting())) {
    await _timeout(1);
    return;
  }

  await _timeout(DURATION[duration ?? 'default']);
}
